import { UrlCreationOptions } from '@angular/router';

export function serializeRouterNavOptions(options?: UrlCreationOptions): unknown {
  return options
    ? {
        ...options,
        relativeTo: options.relativeTo?.toString(),
      }
    : void 0;
}
